import { Component, ChangeEvent } from '@wordpress/element';
import { DealTrackerAds } from '../ads';
import App, { AppContext } from '../App';
import { capitalise } from '../utils';
import { FilterText, FilterDate, FilterTax } from './';

interface FilterProps {
}

export class Filters extends Component<FilterProps> {

    renderContent = ( app: App ) => {
        const { post_type } = app.props.wpProps;
        let { criteria } = app.state;

        const onSubmit = (i: number) => {
            criteria[i].data.submit = true;
            app.setState({criteria, current_page: 1}, app.query);
        }

        const onInputKeyPress = (i: number, e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.which === 13) onSubmit(i);
        }

        const onTextChange = (i: number, e: React.ChangeEvent<HTMLInputElement>) => {
            criteria[i].data.text = e.target.value;
            app.setState({criteria});
        }

        const onDateChange = (i: number, type: string, change: Date) => {
            criteria[i].date[type] = change;
            app.setState({criteria, current_page: 1}, app.query);
        }

        const onTermClick = (i: number, taxonomy: string) => {
            const criteriaIndex = criteria.findIndex(( { name, terms = [] }) => {
                return ( terms.length === 0 ) ? name === taxonomy : terms[0].taxonomy === taxonomy;
            });
            criteria[criteriaIndex].terms[i].checked = !criteria[criteriaIndex].terms[i].checked;
            app.setState({criteria, current_page: 1}, app.query);
        }

        return (
            <div className="pbc-facet-filters search__filter">
                {criteria.map((filter, i) => [
                    <div className={`active pbc-facet-facet pbc-facet-facet--${filter.type}`}>
                        {filter.type !== 'text' && <div className="search__filter-type-title">
                            {capitalise(filter.label || filter.name)}
                        </div>}
                        {filter.type === 'text' && <FilterText value={filter.data} onChange={onTextChange.bind(this, i)} onSubmit={onSubmit.bind(this, i)} onKeyPress={onInputKeyPress.bind(this, i)}/>}
                        {filter.type === 'date' && <FilterDate date={filter.date} onDateChange={onDateChange.bind(this, i)}/>}
                        {filter.type === 'tax' && <FilterTax terms={filter.terms} onTermClick={onTermClick}/>}
                    </div>,
                    <>
                        {filter.type === 'date' &&
                            <>
                                <div className="facet-in-filters-criteria"></div>
                                <div className="search__filters-label">
                                    Filter results by:
                                </div>
                            </>
                        }
                    </>
                ])}
                {post_type === 'deal' && <DealTrackerAds />}
            </div>
        )
    }

    render() {
        return (
            <AppContext.Consumer>
                {this.renderContent}
            </AppContext.Consumer>
        )
    }
}
